import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import KeyCode from 'constants/keys';
import BasicToggle from 'components/BasicToggle';
import './styles.css';

const ShortlistSearch = ({
  search,
  searchPlaceholder,
  searchQueryMinLength,
  searchQueryMaxLength,
  onSendSearchQueryHandler,
  selectedTab,
  onTabSelectHandler,
}) => {
  const [query, changeQuery] = useState(search || '');
  const input = useRef();

  useEffect(() => {
    if (search) {
      changeQuery(search);
      input.current.blur();
    } else if (search === '') {
      changeQuery('');
      input.current.blur();
    }
  }, [search]);

  const searchQueryHandler = e => {
    const { value } = e.target;
    if (value.length <= searchQueryMaxLength) {
      changeQuery(value);
    }
  };

  const handleKeyPress = e => {
    if (e.key === KeyCode.ENTER && query.length >= searchQueryMinLength) {
      onSendSearchQueryHandler(query);
    }
  };

  const handleClickButton = e => {
    if (query.length >= searchQueryMinLength) {
      onSendSearchQueryHandler(query);
    }
  };

  const handleTabSelect = tab => {
    onTabSelectHandler(tab);
  };

  return (
    <div className="shortlist-search">
      <div className="shortlist-search__main">
        <input
          ref={input}
          className="shortlist-search__input"
          name="Search"
          type="text"
          value={query}
          onChange={searchQueryHandler}
          placeholder={searchPlaceholder}
          onKeyPress={handleKeyPress}
        />
        <button className="shortlist-search__btn" onClick={handleClickButton} />
      </div>

      <div className="shortlist-search__tabs">
        <BasicToggle
          defaultClass="shortlist-search__tab"
          toggledClass="shortlist-search__tab--selected"
          defaultCaption="My Shortlists"
          toggledCaption="My Shortlists"
          handler={handleTabSelect}
          value="my"
          selected={selectedTab}
        />
        <BasicToggle
          defaultClass="shortlist-search__tab"
          toggledClass="shortlist-search__tab--selected"
          defaultCaption="Shared with me"
          toggledCaption="Shared with me"
          handler={handleTabSelect}
          value="shared"
          selected={selectedTab}
        />
      </div>
    </div>
  );
};

ShortlistSearch.defaultProps = {
  searchPlaceholder: 'Search',
  searchQueryMinLength: 0,
  searchQueryMaxLength: 100,
};

ShortlistSearch.propTypes = {
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  searchQueryMinLength: PropTypes.number,
  searchQueryMaxLength: PropTypes.number,
  searchPlaceholder: PropTypes.string,
  onSendSearchQueryHandler: PropTypes.func.isRequired,
};

export default ShortlistSearch;
